// extracted by mini-css-extract-plugin
module.exports = {"SepTimeBoard":"SepTimeBoard_SepTimeBoard__8a8Kr"};